// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3iNZK","content":"styles_content__23uiY","tableWrap":"styles_tableWrap__2jhsT"};